import { useEffect } from 'react';

/**
 * Custom hook to set document meta tags
 * Works around react-helmet-async issues with React 19
 */
export function useDocumentMeta({ title, description, canonical, ogTitle, ogDescription, ogUrl, twitterTitle, twitterDescription }) {
  useEffect(() => {
    // Set title
    if (title) {
      document.title = title;
    }

    // Helper function to set or create meta tag by name attribute
    const setMetaByName = (name, content) => {
      if (!content) return;
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Helper function to set or create meta tag by property attribute
    const setMetaByProperty = (property, content) => {
      if (!content) return;
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Set meta tags by name
    if (description) {
      setMetaByName('description', description);
    }

    // Twitter tags (use name attribute)
    if (twitterTitle || ogTitle || title) {
      setMetaByName('twitter:title', twitterTitle || ogTitle || title);
    }
    if (twitterDescription || ogDescription || description) {
      setMetaByName('twitter:description', twitterDescription || ogDescription || description);
    }
    setMetaByName('twitter:card', 'summary_large_image');

    // OG tags (use property attribute)
    if (ogTitle || title) {
      setMetaByProperty('og:title', ogTitle || title);
    }
    if (ogDescription || description) {
      setMetaByProperty('og:description', ogDescription || description);
    }
    if (ogUrl) {
      setMetaByProperty('og:url', ogUrl);
    }

    // Canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }
  }, [title, description, canonical, ogTitle, ogDescription, ogUrl, twitterTitle, twitterDescription]);
}
